var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-container',{attrs:{"id":"bid-register","fluid":"","tag":"section"}},[_c('v-row',{attrs:{"justify":"center"}},[_c('v-col',{attrs:{"cols":"12","md":"10"}},[_c('idc-component-bid-register',{attrs:{"can-create":_vm.canCreate}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }